{
  "components": {
    "BulkPaymentList": {
      "payment_batches": "Payment Batches",
      "attrs": {
        "search_batches": "Search batches..."
      },
      "batch_name": "Batch Name",
      "created": "Created",
      "total_amount": "Total Amount",
      "status": "Status",
      "collection": "Collection",
      "actions": "Actions",
      "requests": "requests",
      "of": "of",
      "paid": "paid",
      "no_batches_found": "No batches found"
    },
    "getStatusBadge": {
      "completed": "Completed",
      "processing": "Processing",
      "failed": "Failed"
    },
    "BulkPaymentListSimplified": {
      "payment_links": "payment links",
      "usd": "MVR"
    },
    "BulkPaymentPreview": {
      "preview_batch": "Preview Batch",
      "some_rows_have_errors": "Some rows have errors",
      "please_fix_the_issues_highlighted_in": "Please fix the issues highlighted in red before proceeding. All\n                required fields must be completed, and payment amounts must be\n                valid numbers greater than zero.",
      "customer": "Customer",
      "contact": "Contact",
      "amount": "Amount",
      "description": "Description",
      "reference": "Reference",
      "payment_links_will_expire_in": "Payment links will expire in",
      "30_days": "30 days",
      "from_creation": "from\n            creation",
      "payment_requests_selected": "payment\n              requests selected",
      "total": "Total:",
      "back": "Back"
    },
    "BulkPaymentUpload": {
      "download_template": "Download template",
      "use_this_csv_template_to_format": "Use this CSV template to format your payment data correctly.\n              Required fields are marked.",
      "download_csv": "Download CSV",
      "file_ready_click_preview_batch_below": "File ready — click \"Preview Batch\" below",
      "or_click_to_browse": "or click to browse",
      "supported_csv": "Supported: .csv",
      "expected_fields": "Expected fields"
    },
    "CardOnFilePayment": {
      "attrs": {
        "search_by_name_email_or_phone": "Search by name, email, or phone...",
        "visa": "Visa",
        "mastercard": "Mastercard",
        "amex": "Amex",
        "eg_invoice_1234": "e.g., Invoice #1234",
        "eg_monthly_subscription": "e.g., Monthly subscription"
      },
      "cards": "cards",
      "no_customers_found": "No customers found",
      "change": "Change",
      "payment_method": "Payment method",
      "expires": "Expires",
      "expired": "Expired",
      "no_cards_on_file": "No cards on file",
      "this_customer_has_no_saved_cards": "This customer has no saved cards.",
      "charge_details": "Charge details",
      "payment_amount": "Payment amount",
      "preview_charge": "Preview charge",
      "confirm_charge": "Confirm Charge",
      "card": "Card",
      "this_will_immediately_charge_the_customers": "This will immediately charge the customer's card. They will\n                    receive a receipt by email.",
      "cancel": "Cancel",
      "confirm_charge_2": "Confirm & Charge"
    },
    "CommonPaymentOptions": {
      "additional_options": "Additional options",
      "store_payment_method": "Store payment method",
      "customer_authorizes_saving_their_payment_method": "Customer authorizes saving their payment method for future\n                    charges. Supported:",
      "cards": "Cards",
      "alipay": "Alipay",
      "wechatpay": "WechatPay",
      "pass_fees_to_customer": "Pass fees to customer",
      "transaction_processing_fees_are_added_on": "Transaction processing fees are added on top of the requested\n                  amount. The customer pays the total including fees.",
      "link_expiration": "Link expiration",
      "expires_in": "Expires in",
      "days_default": "days. Default:",
      "days_change_in": "days\n                — change in",
      "payment_settings": "payment settings",
      "attrs": {
        "mmddyyyy": "MM/DD/YYYY"
      },
      "limit_payment_methods": "Limit payment methods",
      "restrict_which_payment_methods_are_available": "Restrict which payment methods are available. Leave empty to\n                    show all.",
      "clear": "Clear",
      "only_selected_methods_will_be_shown": "Only selected methods will be shown to the customer",
      "success_redirect_url": "Success redirect URL",
      "where_to_redirect_customers_after_a": "Where to redirect customers after a successful payment. Leave\n                blank for default."
    },
    "FixedLinksPayment": {
      "your_fixed_payment_links": "Your fixed payment links",
      "name": "Name",
      "usage": "Usage",
      "total_collected": "Total Collected",
      "payments": "payments",
      "attrs": {
        "copy_link": "Copy link",
        "share_link": "Share link",
        "delete_link_permanently": "Delete link permanently",
        "eg_monthlysubscription_or_donationform": "e.g., monthly-subscription or donation-form",
        "eg_monthly_subscription_or_donation": "e.g., Monthly subscription or Donation",
        "key": "Key",
        "value": "Value"
      },
      "you_havent_created_any_fixed_payment": "You haven't created any fixed payment links yet",
      "fill_out_the_form_below_to": "Fill out the form below to create your first fixed payment link",
      "payment_details": "Payment details",
      "eur": "EUR",
      "gbp": "GBP",
      "link_reference": "Link reference",
      "payment_description": "Payment description",
      "set_expiration_date_and_time": "Set expiration date and time",
      "expiry_date": "Expiry date",
      "su": "Su",
      "mo": "Mo",
      "tu": "Tu",
      "we": "We",
      "th": "Th",
      "fr": "Fr",
      "sa": "Sa",
      "7_days": "7 days",
      "90_days": "90 days",
      "expiry_time": "Expiry time",
      "time_is_in_your_local_timezone": "Time is in your local timezone (",
      "customer_information": "Customer information",
      "specify_what_information_to_collect_from": "Specify what information to collect from customers before payment.",
      "custom_metadata": "Custom metadata",
      "add_metadata_field": "Add metadata field"
    },
    "InstallmentPayment": {
      "how_would_you_like_to_split": "How would you like to split this payment?",
      "payment_schedule": "Payment schedule",
      "split_into_multiple_payments_on_different": "Split into multiple payments on different dates",
      "multiple_people": "Multiple people",
      "split_the_payment_between_different_recipients": "Split the payment between different recipients",
      "commission_split": "Commission split",
      "distribute_payment_between_your_business_and": "Distribute payment between your business and partners",
      "order_reference": "Order reference",
      "attrs": {
        "eg_order_1234_or_project_name": "e.g., Order #1234 or Project Name",
        "select_a_supplier": "Select a supplier",
        "eg_commission_for_services": "e.g., Commission for services",
        "email_address": "Email address",
        "phone_number": "Phone number"
      },
      "payment_links_will_be_automatically_sent": "Payment links will be automatically sent on the \"Send link on\"\n                date. If no date is provided, links will default to being sent\n                at least",
      "days_before_the_due_date": "days before the due date.",
      "configure_supplier_commissions_and_how_payments": "Configure supplier commissions and how payments are split",
      "total_payment_amount": "Total payment amount",
      "commission_type": "Commission type",
      "percentage": "Percentage",
      "fixed_amount": "Fixed amount",
      "select_supplier": "Select supplier",
      "usd": "≈ MVR",
      "add_another_supplier": "Add another supplier",
      "due_date": "Due date",
      "send_link_on": "Send link on",
      "14_days": "14 days",
      "today": "Today",
      "recipient_contact_information": "Recipient contact information",
      "add_another": "Add another",
      "fee_configuration": "Fee configuration",
      "choose_who_pays_the_transaction_processing": "Choose who pays the transaction processing fees",
      "supplier_pays": "Supplier pays",
      "fee_is_deducted_from_the_suppliers": "Fee is deducted from the supplier's commission",
      "my_business_pays": "My business pays",
      "fee_is_deducted_from_your_share": "Fee is deducted from your share of the payment",
      "split_the_fee": "Split the fee",
      "share_the_fee_between_your_business": "Share the fee between your business and the supplier",
      "customer_pays": "Customer pays",
      "fee_is_added_to_the_total": "Fee is added to the total amount paid by the customer",
      "supplier_fee_percentage": "Supplier fee percentage"
    },
    "PaymentForm": {
      "recent_batches": "Recent batches",
      "view_all": "View all"
    },
    "PreAuthPayment": {
      "preauthorization_details": "Pre-authorization details",
      "place_a_temporary_hold_on_the": "Place a temporary hold on the customer's card without charging them.",
      "hold_amount": "Hold amount",
      "attrs": {
        "eg_booking_1234": "e.g., Booking #1234",
        "eg_security_deposit": "e.g., Security deposit"
      },
      "capture_options": "Capture options",
      "choose_how_and_when_to_charge": "Choose how and when to charge the held funds.",
      "manual_capture": "Manual capture",
      "charge_funds_manually_when_needed_from": "Charge funds manually when needed from the transaction detail\n              page.",
      "automatic_capture": "Automatic capture",
      "automatically_charge_the_held_amount_after": "Automatically charge the held amount after a set number of days.",
      "capture_after": "Capture after",
      "days": "days"
    },
    "ProductSelectionPayment": {
      "product_selection": "Product selection",
      "attrs": {
        "search_products": "Search products",
        "search_for_products_in_your_store": "Search for products in your store",
        "search_by_name_category_or_description": "Search by name, category, or description",
        "customer_reference": "Customer reference",
        "email_or_reference_for_your_customer": "Email or reference for your customer",
        "email_or_reference_id": "Email or reference ID"
      },
      "available_products": "Available products",
      "add_to_cart": "Add to cart",
      "selected_products": "Selected products",
      "total": "Total: $",
      "no_products_selected": "No products selected",
      "search_and_add_products_from_your": "Search and add products from your store"
    },
    "RecurringPayment": {
      "subscription_type": "Subscription type",
      "existing_customer": "Existing customer",
      "charge_a_saved_payment_method_on": "Charge a saved payment method on a recurring schedule",
      "new_subscription_link": "New subscription link",
      "send_a_link_to_a_customer": "Send a link to a customer to start a new subscription",
      "attrs": {
        "search_by_name_or_email": "Search by name or email...",
        "john_doe": "John Doe",
        "customerexamplecom": "customer@example.com",
        "eg_premium_membership": "e.g., Premium membership",
        "internal_reference": "Internal reference",
        "search": "Search...",
        "unlimited": "Unlimited"
      },
      "well_send_a_subscription_link_to": "We'll send a subscription link to this customer.",
      "optional": "(optional)",
      "email": "Email",
      "phone": "Phone",
      "subscription_details": "Subscription details",
      "amount_per_billing_period": "Amount per billing period",
      "billing_schedule": "Billing schedule",
      "billing_interval": "Billing interval",
      "no_results": "No results",
      "billing_cycles": "Billing cycles",
      "start_date": "Start date",
      "start_immediately": "Start immediately",
      "trial_period_days": "Trial period (days)",
      "billing_cycle_preview": "Billing cycle preview",
      "trial_period": "Trial period ·",
      "days_free": "days free",
      "continues_indefinitely": "Continues indefinitely…",
      "enter_an_amount_and_billing_interval": "Enter an amount and billing interval to see the preview"
    },
    "RedirectLinkField": {
      "attrs": {
        "where_to_redirect_customers_after_a": "Where to redirect customers after a successful payment"
      },
      "leave_blank_to_use_your_default": "Leave blank to use your default success page"
    },
    "renderSchedulePreview": {
      "review_the_payment_schedule_before_creating": "Review the payment schedule before creating the link.",
      "pending": "Pending",
      "total": "Total",
      "automatic_link_delivery": "Automatic link delivery",
      "payment_links_will_be_sent_automatically": "Payment links will be sent automatically on the scheduled dates.\n              You can also share the master link manually."
    },
    "renderCommissionPreview": {
      "review_the_commission_breakdown_before_creating": "Review the commission breakdown before creating the payment link.",
      "commission_usd": "Commission: MVR",
      "your_share_usd": "Your share: MVR",
      "supplier_commission_breakdown": "Supplier commission breakdown",
      "of_total": "% of total",
      "your_business": "Your business",
      "remaining_after_commission": "Remaining after commission"
    },
    "renderMultiRecipientShare": {
      "send_unique_payment_links_to_each": "Send unique payment links to each recipient",
      "recipient": "Recipient",
      "allow_recipient_to_view_the_total": "Allow recipient to view the total and outstanding amount",
      "recipient_will_only_see_their_portion": "Recipient will only see their portion",
      "copied": "Copied",
      "copy": "Copy",
      "send_payment_link_via": "Send payment link via:",
      "sms": "SMS",
      "both": "Both",
      "email_only": "Email only",
      "sms_only": "SMS only"
    },
    "renderStandardShare": {
      "choose_how_you_want_to_share": "Choose how you want to share this payment link:",
      "send_via_email": "Send via email",
      "send_the_payment_link_to_their": "Send the payment link to their email address",
      "attrs": {
        "nameexamplecom": "name@example.com"
      },
      "send_via_text_message": "Send via text message",
      "send_the_payment_link_to_their_2": "Send the payment link to their phone",
      "generate_qr_code": "Generate QR code",
      "create_a_scannable_qr_code_for": "Create a scannable QR code for the payment link",
      "downloaded": "Downloaded",
      "download_qr_code": "Download QR Code",
      "customers_can_scan_this_qr_code": "Customers can scan this QR code with their phone's camera to\n                  open the payment link",
      "copy_link_to_share": "Copy link to share",
      "copy_the_payment_link_to_share": "Copy the payment link to share yourself"
    },
    "renderFooter": {
      "continue_to_share": "Continue to share",
      "send_to_all_recipients": "Send to all recipients",
      "send": "Send",
      "done": "Done",
      "select_an_option": "Select an option"
    },
    "ShareLinkModal": {
      "review": "Review",
      "share": "Share"
    },
    "ShopProductsPayment": {
      "shop_products": "Shop & products",
      "select_a_shop_and_add_products": "Select a shop and add products to the order.",
      "attrs": {
        "search_products": "Search products..."
      },
      "no_products_found": "No products found",
      "try_a_different_search_term": "Try a different search term",
      "order_summary": "Order summary",
      "item": "item",
      "add_products_from_the_shop": "Add products from the shop",
      "create_payment_link": "Create payment link"
    },
    "StandardPayment": {
      "attrs": {
        "eg_inv1234": "e.g. INV-1234",
        "eg_monthly_subscription": "e.g. Monthly subscription",
        "enter_a_secure_password": "Enter a secure password",
        "search_countries": "Search countries...",
        "eg_proof_of_insurance": "e.g. Proof of insurance",
        "explain_what_document_you_need": "Explain what document you need..."
      },
      "security_settings": "Security settings",
      "control_how_customers_access_this_payment": "Control how customers access this payment link.",
      "public_access": "Public access",
      "anyone_with_the_link_can_pay": "Anyone with the link can pay",
      "password": "Password",
      "require_a_password_to_access": "Require a password to access",
      "email_verification": "Email verification",
      "verify_via_email_code": "Verify via email code",
      "sms_verification": "SMS verification",
      "verify_via_phone_number": "Verify via phone number",
      "geographic_restriction": "Geographic restriction",
      "restrict_by_country": "Restrict by country",
      "document_upload": "Document upload",
      "require_document_before_payment": "Require document before payment",
      "customer_email": "Customer email",
      "customer_phone": "Customer phone",
      "allowed_countries": "Allowed countries",
      "no_countries_found": "No countries found",
      "clear_all": "Clear all",
      "youll_be_notified_when_a_document": "You'll be notified when a document is uploaded. Review and\n                    approve before the customer can pay.",
      "required_document_type": "Required document type",
      "document_name": "Document name",
      "instructions_for_customer": "Instructions for customer",
      "shown_to_the_customer_on_the": "Shown to the customer on the payment page"
    }
  },
  "pages": {
    "getStatusBadge": {
      "paid": "Paid",
      "cancelled": "Cancelled",
      "draft": "Draft"
    },
    "BulkPaymentDetail": {
      "back_to_payment_form": "Back to Payment Form",
      "created_on": "Created on",
      "export": "Export",
      "send_reminders": "Send Reminders",
      "collection_rate": "Collection Rate",
      "payment_requests": "Payment Requests",
      "last_updated_5_mins_ago": "Last updated 5 mins ago",
      "all": "All (",
      "attrs": {
        "search_payments": "Search payments..."
      },
      "resend": "Resend",
      "view_details": "View Details",
      "cancel_request": "Cancel Request",
      "no_payment_requests_found_matching_your": "No payment requests found matching your filters.",
      "this_will_send_payment_reminders_to": "This will send payment reminders to",
      "customers_with_pending_payments": "customers with pending payments."
    },
    "BulkPayments": {
      "all_batches": "All batches",
      "date_created": "Date Created",
      "no_batches_found": "No batches found.",
      "showing": "Showing",
      "to": "to",
      "batches": "batches"
    },
    "VirtualTerminal": {
      "process_a_mail_order_telephone_order": "Process a Mail Order / Telephone Order transaction.",
      "attrs": {
        "eg_product_purchase": "e.g., Product purchase",
        "xxxx_xxxx_xxxx_xxxx": "XXXX XXXX XXXX XXXX",
        "mmyy": "MM/YY",
        "xxx": "XXX",
        "name_as_it_appears_on_card": "Name as it appears on card"
      },
      "card_information": "Card information",
      "card_number": "Card number",
      "cvv_cvc": "CVV / CVC",
      "cardholder_name": "Cardholder name",
      "card_information_is_securely_processed_and": "Card information is securely processed and encrypted end-to-end.",
      "process_payment": "Process payment",
      "processing_payment": "Processing payment",
      "please_wait_while_we_process_the": "Please wait while we process the transaction…",
      "payment_successful": "Payment successful",
      "the_transaction_has_been_approved": "The transaction has been approved.",
      "date": "Date",
      "new_transaction": "New transaction",
      "transaction_failed": "Transaction failed",
      "the_payment_could_not_be_processed": "The payment could not be processed.",
      "transaction_declined_by_issuing_bank_please": "Transaction declined by issuing bank. Please try a\n                        different payment method or contact the card issuer.",
      "try_again": "Try again"
    }
  }
}
